module.exports = __webpack_public_path__ + "static/media/backIcon.f41c9ea3.svg";